import { Dispatch, JSX, ReactNode, SetStateAction, useState } from "react";

interface ModalProviderProps<T> {
  initialState: T;
  children: (props: { modalState: T; setModalState: Dispatch<SetStateAction<T>>; closeModal: () => void }) => ReactNode;
}

const ModalProvider = <T,>({ initialState, children }: ModalProviderProps<T>): JSX.Element => {
  const [modalState, setModalState] = useState<T>(initialState);

  const closeModal = () => setModalState(initialState);

  const renderChildren = (modalState: T, setModalState: Dispatch<SetStateAction<T>>) =>
    children({ modalState, setModalState, closeModal });

  return <>{renderChildren(modalState, setModalState)}</>;
};

export default ModalProvider;
